/* hellomini — Swatch-Zeilen für zusammengelegte Optionen.
 *
 * Gegenstück zu snippets/hellomini-kombi-zeilen.liquid. Eine Kachel steht für
 * einen Teilwert einer echten Shopify-Option („Mit Personalisierung" in
 * „Ohne Standfuß · Mit Personalisierung"). Ein Klick sucht die echte Variante
 * mit diesem Teilwert, die von der aktuellen Auswahl am wenigsten abweicht —
 * bei Gleichstand eine kaufbare, dann die günstigere. Danach werden die
 * versteckten Radios der echten Optionen darauf gesetzt und EIN change-Event
 * ausgelöst. Den Rest erledigt Tinkers <variant-picker> wie bei jedem anderen
 * Wechsel: Section neu laden, Preis/Bild/URL/Formular aktualisieren und die
 * Zeilen mit der neuen Auswahl frisch rendern.
 */
(function () {
  // Das Snippet bindet die Datei bei jedem Re-Render erneut ein.
  if (window.__hmKombiZeilen) return;
  window.__hmKombiZeilen = true;

  function daten(picker) {
    var el = picker.querySelector('script[data-hm-kombi-daten]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function teileVon(d, optionen) {
    return d.zeilen.map(function (z) {
      var teile = String(optionen[z.option - 1] || '').split(d.trenner);
      return (teile[z.teil] || '').trim();
    });
  }

  function besteVariante(d, zeile, wert) {
    var soll = teileVon(d, d.aktuell);
    var best = null;
    var bestScore = -1;
    d.varianten.forEach(function (v) {
      var t = teileVon(d, v.o);
      if (t[zeile] !== wert) return;
      var score = 0;
      for (var i = 0; i < t.length; i++) {
        if (i !== zeile && t[i] === soll[i]) score += 2;
      }
      if (v.a) score += 1;
      if (score > bestScore || (score === bestScore && v.p < best.p)) {
        best = v;
        bestScore = score;
      }
    });
    return best;
  }

  function anwenden(picker, variante) {
    var ausgeloest = null;
    picker.querySelectorAll('fieldset.hm-kombi-native').forEach(function (fs, i) {
      var soll = variante.o[i];
      var input = Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (inp) {
        return inp.value === soll;
      });
      if (input && !input.checked) {
        input.checked = true;
        ausgeloest = input;
      }
    });
    if (!ausgeloest) return;
    // Tinker schreibt ?variant= aus data-variant-id des geänderten Radios.
    // Das Attribut stammt aus der alten Auswahl und kann bei mehreren
    // geänderten Optionen auf eine andere Variante zeigen.
    ausgeloest.dataset.variantId = String(variante.id);
    ausgeloest.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var kachel = e.target.closest('[data-hm-kombi-wert]');
    if (!kachel) return;
    var picker = kachel.closest('variant-picker');
    if (!picker) return;
    e.preventDefault();
    var d = daten(picker);
    if (!d) return;
    var zeile = parseInt(kachel.dataset.hmKombiZeile, 10);
    var wert = kachel.dataset.hmKombiWert;
    if (isNaN(zeile) || teileVon(d, d.aktuell)[zeile] === wert) return;
    var ziel = besteVariante(d, zeile, wert);
    if (!ziel) return;
    // Sofortiges Feedback, bis die Section neu gerendert ist.
    kachel.parentNode.querySelectorAll('.hm-kombi-kachel').forEach(function (k) {
      k.classList.toggle('is-selected', k === kachel);
      k.setAttribute('aria-checked', k === kachel ? 'true' : 'false');
    });
    anwenden(picker, ziel);
  });
})();
